export default "__VITE_ASSET__M0j2JKm8__"